/*global console, _, Modernizr, app*/
/*jshint browser:true, jquery:true, undef:true, multistr: true*/

jQuery( window ).load( function() {
    "use strict";

    var browserWindow = $( this ),
        html = $( document.documentElement );


    // [Add code here...] ::start
    //(function() {
    //})();
    // [Add code here...] ::end
});


jQuery( document ).ready( function($) {
    var browserWindow = $( this ),
        currentDoc    = $( document ),
        html          = $( document.documentElement ),
        body          = $( document.body ),
        masthead      = $( '#masthead' ),
        headNav       = $( '#head-navigation' ),
        mainContent   = $( '.main-content' ),
        smartForm     = html.find( '.smart-form' );


    // [Utilities] ::start
    /*!
     * Determine if an element is in the viewport
     * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
     * @param  {Node}    elem The element
     * @return {Boolean}      Returns true if element is in the viewport
     */
    var isInViewport = function (elem) {
        var distance = elem.getBoundingClientRect();
        return (
            distance.top >= 0 &&
            distance.left >= 0 &&
            distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            distance.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };
    // [Utilities] ::end

    // [Datetimepicker] ::start
    (function() {
        $( '.datetimepicker' ).each( function() {
            $( this ).datetimepicker({
                debug: true,
                format: 'MM/DD/YYYY',
                //minDate: new Date().setHours( 0, 0, 0, 0 ),
                showClose: true
            });
        });
    })();
    // [Datetimepicker] ::end


    // [Form Errors] ::start
    // Check if the form was submitted
    // Then scroll to the error messages
    (function() {
        if ( smartForm.hasClass( 'form-with-errors' ) ) {
            
            var firstElementWithError       = smartForm.find( 'li[data-element-with-error]' ).eq( 0 ),
                firstElementWithErrorTarget = '#' + firstElementWithError.data( 'element-with-error' );

            // Find the elements with errors and set focus on click
            smartForm.find( 'li[data-element-with-error]' ).on( 'click', function (event) {
                var _this    = $( this ),
                    _target  = '#' + _this.data('element-with-error'),
                    _element = $( _target );
                
                _element.focus()
                    .select();
            
                // No need to scroll again
                if ( _target == firstElementWithErrorTarget ) {
                    return false;
                }

                $.scrollTo( _element, {
                    duration: 600, 
                    offset: { 
                        top: -220
                    },
                    onAfter: function() {
                        _element.trigger( 'click' );
                    }
                });

            });
            
            $.scrollTo( firstElementWithError, {
                duration: 1200, 
                onAfter: function() {
                    firstElementWithError.trigger( 'click' );
                }
            });

        }
    })();
    // [Form Errors] ::end


    // [Lightslider] ::start
    (function() {

        $( '.slider--vertical' ).each( function() {

            var lightSlider = $( this ),
                sliderOpts = {
                    gallery: true,
                    item: 1,
                    vertical: false,
                    thumbItem: 4,
                    thumbMargin: 10,
                    slideMargin: 0,
                    pauseOnHover: true,
                    adaptiveHeight: false,
                    prevHtml: 'Prev',
                    nextHtml: 'Next',
                    enableDrag: false,
                    onBeforeSlide: function (el) {
                        $('#current-slide').text(el.getCurrentSlideCount());
                    },
                    onSliderLoad: function (el) {
                        $( el ).lightGallery({
                            selector: $( el ).find('.lslide'),
                            getCaptionFromTitleOrAlt: false
                        });
                    }
                };

            if ( browserWindow.width() > 1199 ) {
                sliderOpts.vertical = true;
                sliderOpts.verticalHeight = 250;
                sliderOpts.vThumbWidth =  85;
            }

            lightSlider.lightSlider( sliderOpts );

            $( '#total-slide-count').text(lightSlider.getTotalSlideCount());
        });
    })();
    // [Lightslider] ::end
    
    
    // [Reset Button] ::start
    (function() {
        $( '.form-reset-btn' ).on( 'click', function (event) {
            event.preventDefault();

            var _form = $( this ).closest( 'form' );
            if (_form) {
                _form[0].reset();
            }

        });
    })();
    // [Reset Button] ::end


    // [Anchor] ::start
    (function() {

        var hash             = body.find( 'a[href="#"]' ),
            externalLink     = body.find( 'a[rel=external]' );

            externalLink.attr( 'target', '_blank' );
            hash.attr( 'href', 'javascript:void(0);' );

    })();
    // [Anchor] ::end


    // [Property Search Dropdown] ::start
    (function() {

        var _goToPropertyTypes = function ()
        {
            var _val = $( this ).selectpicker( 'val' ),
                _url = '/properties/search/property-types-' + _val;

            window.location = _url + '/order-by-list-price-desc';
        };

        $( '#for_buyers_sel' ).on( 'changed.bs.select', _goToPropertyTypes );
        $( '#for_renters_sel' ).on( 'changed.bs.select', _goToPropertyTypes );

    })();
    // [Property Search Dropdown] ::end


    // [Typeahead / Search] ::start
    (function() {

        var _mlsNumberEl = $( '#mls_number' );

        _mlsNumberEl.closest( '.mls-number-group' ).addClass( 'disabled' );
        _mlsNumberEl.prop( 'disabled', true );

        if ( _mlsNumberEl.length > 0 ) {

            _mlsNumberEl.closest( 'form' ).on( 'submit', function (e) {
                e.preventDefault();
            });

            var clearSearchPropertyInput = function ()
            {
                _mlsNumberEl.val( '' );
            };

            $.getJSON( '/api/get-mls-id-suggestions', function ( data ) {

                _mlsNumberEl.closest( '.mls-number-group' ).removeClass( 'disabled' );
                _mlsNumberEl.prop( 'disabled', false );

                _mlsNumberEl.typeahead({
                    source: data,
                    displayText: function (item) {
                        return item.title;
                    },
                    autoSelect: true
                });

                // Hook to detect if the value is empty
                _mlsNumberEl.on('input propertychange paste', function() {
                    var _val = $( this ).val();
                    if ( _val === '' ) {
                        console.log( 'on paste' );
                    }
                });

                _mlsNumberEl.change(function() {
                    var current = _mlsNumberEl.typeahead( 'getActive' );
                    if ( current ) {
                        if ( current.title == _mlsNumberEl.val() ) {
                            window.location = current.href;
                        } else {
                            // Clear the input
                            clearSearchPropertyInput();
                        }
                    }
                });

            })
            .fail(function () {
                console.log( 'error' );
            });
        }

    })();
    // [Typeahead / Search] ::end


    // [Back to Top] ::start
    (function() {

        var backToTopBtn = mainContent.find( '#back-to-top' );

        $( window ).scroll( function() {
            if ( $( this ).scrollTop() > 500 ) {
                backToTopBtn.fadeIn();
            } else {
                backToTopBtn.fadeOut();
            }
        });

        backToTopBtn.on( 'click', function(e) {
            $( 'html, body' ).animate({
                scrollTop: 0
            }, 700);

            e.preventDefault();
        });

    })();
    // [Back to Top] ::end

    // [reCAPTCHA v2 and Invisible reCAPTCHA] ::start
    (() => {
        window.onSubmit = (token) => {
            // $.LoadingOverlay( 'show' );
            
            $( '.smart-form--with-recaptcha' )
                .not( '.recaptcha-explicit' )
                .submit()
                ;
        };
    })();
    // [reCAPTCHA v2 and Invisible reCAPTCHA] ::end

    // [Property Features] ::start
    (() => {
        $( '.list--property-features' ).each( function() {
            var target = $( this ),
                getPropertyFeaturesItemsMiddleChild = Math.ceil(target.find('.list__item').length / 2);

            target.find( '.list__item:nth-child(' + getPropertyFeaturesItemsMiddleChild + ')' ).attr( 'data-child', 'middle' );
        });
    })();
    // [Property Features] ::end

    // [Property Features] ::start
    (() => {
        $('[data-toggle="popover"]').popover();
    })();
    // [Property Features] ::end

    // // [Back to Property Listing] ::start
    // (() => {
    //     var timer;
    //     var scrollToProperty = function () {
    //         clearTimeout(timer);
    //         if ( $( 'section.property, div.listings:not(.hidden) a.property' ).length > 0) {
    //
    //             // property on click event
    //             $( 'section.property, div.listings:not(.hidden) a.property' ).on( 'click', (e) => {
    //                 e.preventDefault();
    //
    //                 var currentTarget = $( e.currentTarget );
    //                 var propertyLinkEl = currentTarget.find( '.property-details-wrapper .link' );
    //                 var propertyHref = currentTarget.attr( 'href' );
    //
    //                 if (propertyLinkEl.length > 0) {
    //                     propertyHref = propertyLinkEl.attr( 'href' );
    //                 }
    //
    //                 window.sessionStorage.setItem( 'current_property_link', propertyHref );
    //
    //                 window.location.href = propertyHref;
    //             });
    //
    //             if ( window.sessionStorage.getItem( 'current_property_link' ) ) {
    //                 var href = window.sessionStorage.getItem( 'current_property_link' );
    //
    //                 if ( $( 'section.property, div.listings:not(.hidden) a.property' ).length > 0) {
    //                     var link = $( `a.link[href="${href}"]` );
    //                     var scrollToEl = link.closest( 'section.property, li.list__item' );
    //
    //                     if (scrollToEl.length > 0) {
    //                         $([document.documentElement, document.body]).animate({
    //                             scrollTop: scrollToEl.offset().top - 40
    //                         }, 3000, function () {
    //                             if (!isInViewport(scrollToEl[0])) {
    //                                 timer = setTimeout(scrollToProperty, 250);
    //                             } else {
    //                                 window.sessionStorage.removeItem( 'current_property_link' );
    //                             }
    //                         });
    //                     }
    //                 }
    //
    //             }
    //         } else {
    //             timer = setTimeout(scrollToProperty, 250);
    //         }
    //     };
    //
    //     setTimeout(scrollToProperty, 250);
    //
    // })();
    // // [Back to Property Listing] ::end
});
